import { render } from "./SourceMarkupChips.vue?vue&type=template&id=55452984&scoped=true"
import script from "./SourceMarkupChips.vue?vue&type=script&lang=js"
export * from "./SourceMarkupChips.vue?vue&type=script&lang=js"

import "./SourceMarkupChips.vue?vue&type=style&index=0&id=55452984&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55452984"]])

export default __exports__